import React from 'react';

import CSSModule from './ShinroArticleCard.module.scss';

export type ShinroArticleCardProps = {
  image: string;
  title: string;
  url: string;
};

const ShinroArticleCard: React.FC<ShinroArticleCardProps> = ({
  image,
  title,
  url,
}) => {
  const wrapperProps = {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer',
    className: CSSModule.ShinroArticleCard,
    style: { cursor: 'pointer', textDecoration: 'none' },
  };

  return (
    <a {...wrapperProps}>
      <div className={CSSModule.ShinroArticleCard__ImageWrapper}>
        <img
          src={image}
          alt={title}
          className={CSSModule.ShinroArticleCard__Image}
        />
      </div>
      <div className={CSSModule.ShinroArticleCard__Body}>
        <h3 className={CSSModule.ShinroArticleCard__Title}>{title}</h3>
      </div>
    </a>
  );
};

export default ShinroArticleCard;
